export default __webpack_public_path__ + "static/media/DHCT_Logo.ff039835.png";